module.exports = __webpack_public_path__ + "img/cap_06.d95082b1.jpg";